import { render, staticRenderFns } from "./QueryFunctionSkeleton.vue?vue&type=template&id=43b980ca"
import script from "./QueryFunctionSkeleton.vue?vue&type=script&lang=js"
export * from "./QueryFunctionSkeleton.vue?vue&type=script&lang=js"
import style0 from "./QueryFunctionSkeleton.vue?vue&type=style&index=0&id=43b980ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports